// The TTP user sharing its oFFFcourse premium with the students UA invites.
export const STUDENT_PREMIUM_SHARED_BY = 469705;

// What saveSharedPremium needs to give the student that premium, read from the
// claims of the session GoPeople's accept returns: the student's TTP user id and
// TTP access token. Null when the session lacks either (no TTP account).
export const studentPremiumRequest = (sessionClaims) => {
  const ttpUserId = sessionClaims?.ttp_user_id;
  const token = sessionClaims?.apiTtp_token?.access_token;
  if (!ttpUserId || !token) {
    return null;
  }
  return {
    token,
    users: [ttpUserId],
    premiumSharedBy: STUDENT_PREMIUM_SHARED_BY,
  };
};
